export function addCurrent(chatbotflow) {
  return {
    type: 'ADD_CURRENT',
    chatbotflow,
  }
}
